// extracted by mini-css-extract-plugin
export default {"md":"markdown___md___cd1cadb5","more":"markdown___more___b6df6e15"};